/*
 * NOTE: We want to maintain this component level template as .ts file so we can add comments.
 */

import { LegendPlacement } from '../../../src/modules/components/cartesian';

export default {
  name: 'dashify:Scatter',
  title: 'Scatter',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'scatter'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'Oct 12, 2023, 09:03 AM',
  spec: {
    props: {
      highchartsConfig: {},
      customConfig: {
        legendPlacement: LegendPlacement.BOTTOM,
      },
    },
    // Highcharts config for legend placement based on Particle
    legendPlacements: {
      bottom: {
        legend: {
          align: 'left',
          layout: 'horizontal',
          verticalAlign: 'bottom',
        },
      },
      right: {
        legend: {
          align: 'right',
          layout: 'vertical',
          verticalAlign: 'middle',
        },
      },
    },
    legendConfig: '/${ $lookup(legendPlacements, props.customConfig.legendPlacement) }',
    defaults: {
      series: [],
      chart: {
        type: 'scatter',
        zoomType: 'xy',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        style: {
          fontFamily: 'var(--typography-font-body)',
        },
        styledMode: false,
      },
      xAxis: {
        title: {
          text: '',
        },
        labels: {
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true,
        min: 0,
      },
      yAxis: {
        gridLineWidth: 1,
        gridLineDashStyle: 'shortdot',
        gridLineColor: 'var(--color-default-border-medium)',
        title: {
          text: '',
        },
        labels: {
          format: '{value}',
          style: {
            fontFamily: 'var(--typography-font-body)',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: '400',
            color: 'var(--color-default-text-medium)',
            backgroundColor: 'var(--color-default-bg)',
          },
        },
        max: 100,
      },
      plotOptions: {
        scatter: {
          marker: {
            radius: 5,
            states: {
              hover: {
                enabled: true,
              },
            },
          },
          states: {
            hover: {
              marker: {
                enabled: false,
              },
            },
          },
        },
        series: {
          marker: {
            enabled: true,
          },
        },
      },
      tooltip: {
        valueDecimals: 2,
        valueSuffix: '%',
        headerFormat: '{series.name}<br>',
        pointFormat: '<b>{point.x:.2f}</b>, <b>{point.y:.2f}<b>%',
        useHTML: true,
        outside: true,
        backgroundColor: 'var(--color-default-bg)',
        style: {
          fontFamily: 'var(--typography-font-body)',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          color: 'var(--color-default-text)',
          backgroundColor: 'var(--color-default-bg)',
        },
      },
      legend: {
        enabled: true,
        symbolWidth: 1,
        symbolPadding: 10,
        itemStyle: {
          fontFamily: 'var(--typography-font-body)',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '18px',
          color: 'var(--color-default-text-medium)',
          backgroundColor: 'var(--color-default-bg)',
        },
        itemHoverStyle: {
          color: 'var(--color-default-text)',
        },
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    },
    seriesLength: '/${ $reduce(props.highchartsConfig.series, function ($acc, $val) { $acc + $count($val.data) }, 0) }',
    view: [
      [
        'dashify:If',
        { condition: '/${ seriesLength > 0 }' },
        [
          [
            'dashify:Then',
            {},
            [['dashify:Highcharts', '/${ $defaultsDeep({}, legendConfig, props.highchartsConfig, defaults) }']],
          ],
          ['dashify:Else', {}, [['dashify:EmptyBox']]],
        ],
      ],
    ],
  },
};
